<template>
  <v-dialog v-model="dialog" width="600" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        class="create-item"
        color="#2CBF56"
        depressed
        rounded
      >
        Создать роль
        <v-icon class="ml-2" size="20">mdi-plus-circle</v-icon>
      </v-btn>
    </template>
    <v-card class="rounded-lg">
      <v-card-title class="pb-0">
        <v-row align="center" justify="space-between">
          <v-col class="px-0" cols="auto"></v-col>
          <v-col class="px-0" cols="auto">
            <p class="dialog-title">Создать роль</p>
          </v-col>
          <v-col class="px-0" cols="auto">
            <v-btn icon @click="resetState">
              <v-icon size="30" color="error">mdi-close-thick</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text style="padding: 15px 40px">
        <v-form v-model="valid" valid>
          <div class="input-wrapper">
            <label for="roles.name">Название роли </label>
            <v-text-field
              autocomplete="off"
              placeholder="Введите название роли "
              v-model="roles.name"
              id="roles.name"
              outlined
              dense
            />
          </div>
          <div class="input-wrapper">
            <label for="roles_key"
              >Привилегия <span class="red--text">*</span>
            </label>
            <v-select
              placeholder="Выберите привилегии"
              v-model="roles.privileges"
              :items="privileges"
              item-text="name"
              item-value="id"
              id="roles_key"
              multiple
              outlined
              dense
            />
          </div>
          <div class="input-wrapper">
            <label for="roles.description">Описание </label>
            <v-text-field
              autocomplete="off"
              placeholder="Введите описание"
              v-model="roles.description"
              id="roles.description"
              outlined
              dense
            />
          </div>
          <v-btn
            @click="createRoles"
            :disabled="!valid"
            :loading="loading"
            class="save-btn"
            depressed
            >Сохранить</v-btn
          >
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CreateRoles",
  props: {
    privileges: {
      type: Array,
      required: true,
    },
  },
  data: () => {
    return {
      roles: {},
      dialog: false,
      loading: false,
      valid: false,
      rules: {
        required: [(v) => !!v || "Поле обязательно для заполнения"],
      },
    };
  },
  methods: {
    resetState() {
      this.roles = {};
      this.dialog = false;
      this.loading = false;
    },
    async createRoles() {
      this.loading = true;
      try {
        await this.$axios.post("privileges/roles/create/", this.roles);
        this.$root.$emit("showCustomSuccess", "Роль успешно создан!");
        this.$emit("refreshData");
      } catch (result) {
        this.$root.$emit("showCustomError", result);
      } finally {
        this.resetState();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.create-item {
  width: 240px;
  height: 41px;

  font-family: Gilroy-Medium, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  letter-spacing: 0.1px;
  color: #ffffff;
  text-transform: none !important;
}
.dialog-title {
  font-family: Gilroy-Medium, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 26px;
  line-height: 31px;
  text-align: center;
  color: #3474d3;
}
.preview {
  position: relative;
  height: 125px;
  width: 125px;

  .delete-btn {
    position: absolute;
    right: 0;
    top: 0;
  }
}
</style>
